import {Component, OnInit} from '@angular/core';
import {EnquiryService} from '../../../shared/services/enquiry.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../../shared/services/alert.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-enquiry',
    templateUrl: './enquiry.component.html',
    styleUrls: ['./enquiry.component.scss']
})
export class EnquiryComponent implements OnInit {
    enquiries: any;
    addEnquiryForm: FormGroup;

    constructor(
        private enquiryService: EnquiryService,
        private formBuilder: FormBuilder,
        private alertService: AlertService,
    ) {

    }

    ngOnInit(): void {
        window.scroll(0, 0);
        // this.get();
        this.addEnquiryForm = this.formBuilder.group({
            name: ['', Validators.required],
            'email': ['', Validators.required],
            'contact': ['', Validators.required],
            'alternate_contact': ['', Validators.required],
            'city': ['', Validators.required],
            'state': ['', Validators.required],
            'course_type': ['', Validators.required],
            'course': ['', Validators.required],
            'message': ['', Validators.required],
        });
    }

    // get() {
    //     this.enquiryService.get({status: 'ACTIVE'}).subscribe(data => {
    //         if (data && data['data'].length > 0) {
    //             this.enquiries = data['data'];
    //         }
    //     })
    // }

    submit() {
        if (!this.addEnquiryForm.valid) {
            this.showWarningAlert();
            return false;
        }
        const params = {
            'name': this.addEnquiryForm.value.name,
            'email': this.addEnquiryForm.value.email,
            'contact': this.addEnquiryForm.value.contact,
            'alternate_contact': this.addEnquiryForm.value.alternate_contact,
            'city': this.addEnquiryForm.value.city,
            'state': this.addEnquiryForm.value.state,
            'course_type': this.addEnquiryForm.value.course_type,
            'course': this.addEnquiryForm.value.course,
            'message': this.addEnquiryForm.value.message,
        };
        this.enquiryService.create(params).subscribe(data => {
            this.showAlert();
            this.addEnquiryForm.reset();
        }, error => {
            this.showWarningAlert();
        });
    }

    showAlert() {
        Swal.fire({
            title: 'Enquiry Submitted!',
            text: 'We will contact you as soon as possible',
            icon: 'success',
            confirmButtonText: 'OK',
        });
    }

    showWarningAlert() {
        Swal.fire({
            title: 'Field Missing!',
            icon: 'info',
            html: 'All Fields are required, please fill all fields correctly!',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok!',
            // cancelButtonText: '<i class="fa fa-check"></i> Cancel',
        });
    }

}
